import { OptionWithIdType } from '~/features/types';
import { getData } from '~/utils/service';
import { SPECIALTY_ROUTE_NAME } from './constants';

export const SPECIALTY_API_CALLS = {
  get: async (props: {
    specialtyBoardId: string;
    transformResponse?: (data: string) => OptionWithIdType[];
  }): Promise<OptionWithIdType[]> => {
    return await getData(SPECIALTY_ROUTE_NAME, {
      pathParams: { specialtyBoardId: props.specialtyBoardId },
      transformResponse: props.transformResponse,
    });
  },
};
